module.exports = __webpack_public_path__ + "instagram.png?d7aa387ceb1577d59a8d7dc6d64a0c82";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instagram.png
// module id = 33
// module chunks = 0